import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { baseUrl } from 'libs/core/src/lib/configs/baseUrl';
import { setStoredLoginResponse } from 'libs/core/src/lib/utils/auth-storage';
import {
  IClient,
  IIndividualClient,
  ILoginResponse,
  IOtpRequest,
  ISelfServiceClientRequest,
  ISuccessulResponse,
} from '@inshuwa-client/models';
import { Observable, tap } from 'rxjs';
import { rememberOtpContact, withOtpContact } from '../utils/otp-contact';

@Injectable({
  providedIn: 'root',
})
export class ClientAuthService {
  private http = inject(HttpClient);

  public createIndividualClient(
    client: Partial<ISelfServiceClientRequest>,
  ): Observable<ISuccessulResponse> {
    rememberOtpContact(client.phoneNumber, client.email);
    return this.http.post<ISuccessulResponse>(
      `${baseUrl()}/clients/individuals/registration/initiate`,
      client,
    );
  }

  public verifyOtp(otpRequest: IOtpRequest): Observable<ILoginResponse> {
    return this.http
      .post<ILoginResponse>(`${baseUrl()}/clients/verify-otp`, withOtpContact(otpRequest))
      .pipe(
        tap((res) => {
          if (!res.isTwoFactorRequired) {
            setStoredLoginResponse(res);
          }
        }),
      );
  }

  public submitOtp(otpRequest: IOtpRequest): Observable<IClient> {
    return this.http.post<IClient>(
      `${baseUrl()}/clients/registration`,
      withOtpContact(otpRequest),
    );
  }

  public fetchKycByPhone(phoneNumber: string): Observable<IIndividualClient> {
    return this.http.get<IIndividualClient>(
      `${baseUrl()}/clients/individuals/kyc/${phoneNumber}`,
    );
  }

  public verifyKycRegistrationOtp(
    otpRequest: IOtpRequest,
  ): Observable<ILoginResponse> {
    return this.http
      .post<ILoginResponse>(
        `${baseUrl()}/clients/registration/verify`,
        withOtpContact(otpRequest),
      )
      .pipe(
        tap((res) => {
          setStoredLoginResponse(res);
        }),
      );
  }

  public SSOLogin(params: {
    token?: string;
    msisdn?: string;
    firstName?: string;
    lastName?: string;
    apiKey?: string;
    partnerId: number;
  }): Observable<ILoginResponse | null> {
    return this.http
      .post<ILoginResponse>(`${baseUrl()}/auth/clients/sso-login`, params)
      .pipe(
        tap((res) => {
          setStoredLoginResponse(res);
        }),
      );
  }
}
